/** Max OOO hours per week — mirrors the employee_ooo.hours CHECK constraint. */
export const MAX_OOO_HOURS = 80;
